import PartnerProductsAdd from "./PartnerProductsAdd";

export default PartnerProductsAdd;
